import * as React from "react";
const _ = require('lodash');
const ReactModal = require('react-modal');
import Filters from './filters';
export default class Filter extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            this.props.updateMobileToggle();
        };
        this.customStyle = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
            content: {
                background: '#fff',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                padding: '20px',
                width: '85%',
                height: '100%',
            }
        };
        this.customClasses = {
            afterOpen: 'afterOpen',
            base: 'base mobile-filter-modal',
            beforeClose: 'beforeClose'
        };
        this.customOverlayClasses = {
            afterOpen: 'afterOpen',
            base: 'base',
            beforeClose: 'beforeClose'
        };
        this.customAriaVariables = {
            labelledby: 'labelledby',
            describedby: 'describedby'
        };
    }
    render() {
        return (React.createElement(ReactModal, { isOpen: this.props.toggleMobile || false, onRequestClose: this.toggle, contentLabel: "filter label", style: this.customStyle, className: this.customClasses, overlayClassName: this.customOverlayClasses, bodyOpenClassName: 'bodyOpenClassName', aria: this.customAriaVariables },
            React.createElement("h2", { className: "filter-header", style: { display: "flex", alignItems: "center", borderBottom: "none" } },
                "Filters",
                React.createElement("i", { className: "fa fa-times", style: { marginLeft: "auto", cursor: "pointer" }, onClick: this.toggle })),
            React.createElement(Filters, { VarietalList: this.props.VarietalList, CountryList: this.props.CountryList, RegionList: this.props.RegionList, VintageList: this.props.VintageList, ColourList: this.props.ColourList, ContainerTypeList: this.props.ContainerTypeList, VolumeList: this.props.VolumeList, AgentList: this.props.AgentList, SupplierList: this.props.SupplierList, PercAlcList: this.props.PercAlcList, SweetnessList: this.props.SweetnessList, IBUList: this.props.IBUList, AromaList: this.props.AromaList, currentFilter: this.props.currentFilter, updateSubFilter: this.props.updateSubFilter, updateMinMaxFilter: this.props.updateMinMaxFilter, TypesList: this.props.TypesList, CatList: this.props.CatList, updateOrderBy: this.props.updateOrderBy, currentOrderBy: this.props.currentOrderBy, orderByOptions: this.props.orderByOptions, albertaMade: this.props.albertaMade, updateAlbertaMade: this.props.updateAlbertaMade })));
    }
}
;
//# sourceMappingURL=mobile-filters.js.map